//certifications
export const GetPersonnelCertifications = (personnelID) => {

  return $.get('Personnel/GetPersonnelCertifications?PersonnelId=' + personnelID)

}

export const AddPersonnelCertification = (model) => {
//  return $.post('Personnel/AddPersonnelCertification',model)
  return $.ajax({
    url: 'Personnel/AddPersonnelCertification',
    data: model,
    processData: false,
    contentType: false,

    cache: false,
    type: 'POST'
  })

}

export const DeletePersonnelCertification = (PersonnelCertificationId) => {

  return $.post('Personnel/DeletePersonnelCertification?PersonnelCertificationId=' + PersonnelCertificationId)

}

export const UpdateCertificationType = (model) => {
  return $.ajax({
    url: 'Personnel/UpdatePersonnelCertification',
    data: model,
    processData: false,
    contentType: false,

    cache: false,
    type: 'POST'
  })
  // return $.post('Personnel/UpdateCertificationType',model)

}

export const GetCertificationTypes = () => {

  return $.get('Personnel/GetCertificationTypes?activestatus='+true)

}









// WEBPACK FOOTER //
// ./src/components/ManagePersonnelCertifications/ManagePersonnelCertifications.Services.js